module.exports = __webpack_public_path__ + "img/activity.dba46a4a.jpg";